import GenQr from "pages/GenQr";
import Home from "../pages/Home";
import RollUp from "../pages/RollUp";
import UploadExcelDay from "pages/UploadExcelDay";

export const publicRoutes = [
  {
    key: "forgot-password",
    path: "/",
    element: <Home />,
    label: "Trang chủ",
    icon: <></>,
  },
  {
    key: "forgot-password",
    path: "/roll-up",
    element: <RollUp />,
    label: "Đăng nhập",
    icon: <></>,
  },
  {
    key: "upload-day",
    path: "/upload-day",
    element: <UploadExcelDay />,
    label: "Tải lên",
    icon: <></>,
  },
  {
    key: "create-qr",
    path: "/create-qr",
    element: <GenQr />,
    label: "Đăng nhập",
    icon: <></>,
  },
];
